import { Card } from '@chakra-ui/react';
import React from 'react';

import { StackCreatorSkeleton } from './CreatorSkeleton';

interface StackCreatorSkeletonProps {
  count?: number;
}

export const StackCreatorSkeletons: React.FC<StackCreatorSkeletonProps> = ({
  count = 2,
}) => {
  return (
    <Card
      boxShadow="0"
      backgroundColor="white"
      border="1px solid"
      borderBottomWidth={{ base: '0', sm: '1px' }}
      borderBottomStyle={{ base: 'none', sm: 'solid' }}
      borderBottomColor={{ base: 'transparent', sm: 'gray.200' }}
      borderColor="primary.100"
      marginBottom={{
        base: 0,
        sm: 5,
      }}
      borderRadius={{ base: 0, sm: '12px' }}
    >
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <StackCreatorSkeleton key={i} />
        ))}
    </Card>
  );
};
